import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ICommsTemplate, ICommsTemplateSearch } from '../../interfaces/comms-template';
import { ActivatedRoute } from '@angular/router';
import { CommsTemplateService } from '../../services/comms-template.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { OrganisationsService } from '../../services/organisations.service';
import { IOrganisationFilter } from '../../interfaces/organisation-filter';
import { ICommsTemplatePreviewRequest } from '../../interfaces/comms-template-preview-request';
import { ICommsTemplatePreviewResponse } from '../../interfaces/comms-template-preview-response';
import { CommsEventService } from '../../services/comms-event.service';
import { CommsTypeEnum, CommsTypeName } from '../../interfaces/comms-template/comms-type';
import { MergeModelEnum, MergeModelName } from '../../interfaces/comms-template/comms-merge-model';
import { ICommsTemplateExclude } from '../../interfaces/comms-template-exclude';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'comms-template',
  styleUrls: ['./comms-template.component.scss'],
  templateUrl: 'comms-template.component.html',
})
export class CommsTemplateComponent implements OnInit {
  public commsTemplates: ICommsTemplate[] = [];

  public commsTypeChoices: SelectItem[] = [];
  public filterCommsTypeChoices: SelectItem[] = [];

  public commsEventChoices: SelectItem[] = [];
  public filterCommsEventChoices: SelectItem[] = [];

  title = 'comms-template';
  uniquePlaceholder: string = '';

  public filterIsWrapperChoices: SelectItem[] = [
    { value: null, label: 'All Template Types' },
    { value: false, label: 'Content Templates' },
    { value: true, label: 'Wrapper Templates' },
  ];

  public customerChoices: SelectItem[];
  public exclusionChoices: SelectItem[];
  public filterCustomerChoices: SelectItem[] = [];

  public previewResponse: ICommsTemplatePreviewResponse;
  public previewModel: ICommsTemplatePreviewResponse;
  public wrapperChoices: SelectItem[];

  public selectedTemplate: ICommsTemplate;
  public includeItem: SelectItem[];
  public excludeItem: SelectItem[];
  public isLoaded: boolean = true;
  public previewOK: boolean = false;
  public bracketDifference: number = 0;
  public showEditForm: boolean = false;
  public loading: boolean = false;
  public excludedCount = null;
  public formGroup: UntypedFormGroup;
  public searchForm: UntypedFormGroup;
  public testArray: any[];
  public currentId: number = 0;
  public templateSyntaxOK = true;
  public MergeModelName = MergeModelName;
  public CommsTypeName = CommsTypeName;

  public showVehicleVariables: boolean = true;
  public showDisabledFor: boolean = false;
  public showTaskVariables: boolean = true;
  public showTaskStepVariables: boolean = true;
  public showText: boolean = true;
  public showOrderVariables: boolean = true;
  public showJobVariables: boolean = true;
  isLoading: boolean = true;

  public eventModels: any[] = [];

  public prefixes = {
    taskStep: { task: 'task', order: 'task.order', vehicle: 'task.vehicle', job: 'task.order.job' },
    task: { order: 'order', vehicle: 'vehicle', job: 'order.job' },
    order: { job: 'task.order.job' },
  };

  public templateVariables = {
    systemVariables: [
      { param: 'site_name', desc: 'Site Name' },
      { param: 'site_phone', desc: 'Site Phone' },
      { param: 'site_email', desc: 'Site Email' },
    ],
  };

  public excludedCustomers: SelectItem[];
  public includedCustomers: SelectItem[];
  public templateFileChoices: SelectItem[] = [];

  constructor(
    private commsTemplateService: CommsTemplateService,
    private formBuilder: UntypedFormBuilder,
    private organisationsService: OrganisationsService,
    private commsEventService: CommsEventService,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit() {
    this.fetchCommTypeChoices();
    this.fetchCommEventChoices();
    this.fetchCustomerChoices();
    this.buildForms();
    this.filterCommTemplates();
    this.fetchWrapperChoices();
    this.fetchTemplateFileChoices();
  }

  moveToExcluded(event) {
    var index = this.includedCustomers.indexOf(event.data);
    this.excludedCustomers = [...this.excludedCustomers, event.data];
    this.includedCustomers = this.includedCustomers
      .slice(0, index)
      .concat(this.includedCustomers.slice(index + 1));
    this.commsTemplateService.addCommsTemplateExclude(this.selectedTemplate.id, event.data.value);

    this.excludedCount = this.excludedCustomers.length;
  }

  moveToIncluded(item) {
    var index = this.excludedCustomers.indexOf(item);
    this.includedCustomers = [...this.includedCustomers, item];
    this.excludedCustomers = this.excludedCustomers
      .slice(0, index)
      .concat(this.excludedCustomers.slice(index + 1));

    this.commsTemplateService.removeCommsTemplateExclude(this.selectedTemplate.id, item.value);

    this.excludedCount = this.excludedCustomers.length;
  }

  changedCommsEvent(eventId) {
    let model = this.eventModels.find((x) => x.id == eventId);
    this.uniquePlaceholder = model.mergeModel + '.id';
  }

  checkTemplateSyntax(x: string) {
    this.bracketDifference = this.matchedBrackets(x);
    this.templateSyntaxOK = this.bracketDifference == 0;
  }

  fetchCommEventChoices() {
    this.commsEventService.getCommsEvents().then((myEvents) => {
      this.commsEventChoices = [];
      this.filterCommsEventChoices = [];

      this.commsEventChoices.push({ value: null, label: 'Select Event Code' });
      this.filterCommsEventChoices.push({ value: null, label: 'All Event Codes' });

      myEvents
        .sort((a, b) => a.commsEventCode.localeCompare(b.commsEventCode))
        .forEach((x) => {
          x.mergeModelName = MergeModelName[x.mergeModel];

          this.commsEventChoices.push({
            value: x.id,
            label: x.commsEventCode + ' (' + x.mergeModelName + ') : ' + x.title,
          });

          this.filterCommsEventChoices.push({
            value: x.id,
            label: x.commsEventCode,
          });
        });

      this.eventModels = myEvents.map((x) => {
        return { id: x.id, mergeModel: MergeModelName[x.mergeModel] };
      });
    });
  }

  async searchCommTemplates(searchVars: ICommsTemplateSearch) {
    return this.commsTemplateService.getCommsTemplates(searchVars);
  }

  filterCommTemplates() {
    this.searchCommTemplates(this.searchForm.value).then((x) => {
      x.forEach((ct) => {
        ct.commsEvent.mergeModelName = MergeModelName[ct.commsEvent.mergeModel];
      });

      this.isLoading = false;
      this.commsTemplates = x;
    });
  }

  fetchCustomerChoices() {
    var organisationFilter: IOrganisationFilter = {
      filters: {
        organisationTypeId: { value: 2 },
      },
    };

    this.organisationsService.getSelectList(organisationFilter).then((x) => {
      this.exclusionChoices = x.slice(); // Clone the array
      this.customerChoices = x.slice(); // Clone the array
      this.filterCustomerChoices = x.slice(); // Clone the array

      this.customerChoices.unshift({ value: null, label: 'Default Template for Customers' });
      this.customerChoices.unshift({ value: -1, label: 'Select Template' });

      this.filterCustomerChoices.unshift({ value: -1, label: 'Default Templates Only' });
      this.filterCustomerChoices.unshift({
        value: null,
        label: 'Default + Customer Specific Templates',
      });
    });
  }

  fetchWrapperChoices() {
    this.wrapperChoices = [];

    this.commsTemplateService.fetchTemplateWrappers().then((response: ICommsTemplate[]) => {
      this.wrapperChoices.push({ value: null, label: 'No Wrapper' });

      for (var item of response) {
        this.wrapperChoices.push({ value: item.id, label: item.templateName });
      }
    });
  }

  fetchCommTypeChoices() {
    this.commsTypeChoices = [];
    this.filterCommsTypeChoices = [];

    this.commsTypeChoices.push({ value: null, label: 'Select Communication Method' });

    for (const [key, value] of Object.entries(CommsTypeName)) {
      this.commsTypeChoices.push({ value: key, label: value });
    }

    this.filterCommsTypeChoices.push({ value: null, label: 'All Comms Types' });

    for (const [key, value] of Object.entries(CommsTypeName)) {
      this.filterCommsTypeChoices.push({ value: key, label: value });
    }
  }

  buildForms() {
    this.searchForm = this.formBuilder.group({
      commsEventId: [''],
      customerId: [''],
      commsType: [''],
      isWrapper: [''],
    });

    this.formGroup = this.formBuilder.group({
      id: [''],
      commsEventId: [''],
      commsType: [''],
      customerId: [''],
      subjectTemplate: [''],
      bodyTemplate: [''],
      senderAddress: [''],
      senderName: [''],
      replyToAddress: [''],
      replyToName: [''],
      recipientAddress: [''],
      bccAddress: [''],
      recipientName: [''],
      active: [''],
      previewId: [''],
      previewRecipient: [''],
      wrapperId: [''],
      isWrapper: [''],
      templateName: [''],
      allowDuplicate: [false],
      uniqueIdTemplate: [''],
      templateFile: [''],
    });
  }

  canSave() {
    return this.f.commsEventId > 0 && this.f.commsType > 0;
  }

  canPreview() {
    return (
      this.f.commsEventId > 0 &&
      this.f.commsType > 0 &&
      this.f.previewId > 0 &&
      this.templateSyntaxOK
    );
  }

  canSendTest() {
    return this.canPreview() && this.f.previewRecipient?.length > 0;
  }

  formObject() {
    var f = this.formGroup.value;

    return <ICommsTemplate>{
      id: f.id,
      senderAddress: f.senderAddress,
      senderName: f.senderName,
      replyToAddress: f.replyToAddress,
      replyToName: f.replyToName,
      recipientAddress: f.recipientAddress,
      bccAddress: f.bccAddress,
      recipientName: f.recipientName,
      active: f.active,
      subjectTemplate: f.subjectTemplate,
      bodyTemplate: f.bodyTemplate,
      commsEventId: f.commsEventId,
      commsType: f.commsType,
      customerId: f.customerId,
      isWrapper: f.isWrapper,
      wrapperId: f.wrapperId,
      templateName: f.templateName,
      uniqueIdTemplate: f.uniqueIdTemplate,
      allowDuplicate: f.allowDuplicate,
      templateFile: f.templateFile,
    };
  }

  countOccurences(searchFor: string, inString: string) {
    return inString.split(searchFor).length - 1;
  }

  matchedBrackets(x: string) {
    var openBrackets = this.countOccurences('{{', x);
    var closedBrackets = this.countOccurences('}}', x);

    console.log(openBrackets + ' - ' + closedBrackets);

    return openBrackets - closedBrackets;
  }

  async sendTest() {
    var saveObject = this.formObject();

    this.commsTemplateService
      .sendTest(<ICommsTemplatePreviewRequest>{
        commsTemplate: saveObject,
        previewId: this.f.previewId,
        previewRecipient: this.f.previewRecipient,
      })
      .then((response) => {});
  }
  async showPreviewModel() {
    var saveObject = this.formObject();

    this.previewModel = null;

    this.commsTemplateService
      .previewModel(<ICommsTemplatePreviewRequest>{
        commsTemplate: saveObject,
        previewId: this.f.previewId,
        previewRecipient:
          this.f.previewRecipient.length > 0 ? this.f.previewRecipient : this.f.recipientAddress,
      })
      .then((response) => {
        this.previewModel = response;
      });
  }

  async preview() {
    var saveObject = this.formObject();

    this.previewResponse = null;

    this.commsTemplateService
      .previewTemplate(<ICommsTemplatePreviewRequest>{
        commsTemplate: saveObject,
        previewId: this.f.previewId,
        previewRecipient:
          this.f.previewRecipient.length > 0 ? this.f.previewRecipient : this.f.recipientAddress,
      })
      .then((response) => {
        this.previewResponse = response;
        this.previewOK = !!(response != null && response.success);
      });
  }

  async save() {
    var saveObject = this.formObject();

    this.commsTemplateService.saveTemplate({ commsTemplate: saveObject }).then((response) => {
      this.formGroup.patchValue({
        id: response.id,
      });

      this.showEditForm = false;
      this.filterCommTemplates();
    });
  }

  async deleteTemplate() {
    await this.commsTemplateService.deleteTemplate(this.selectedTemplate.id);

    this.filterCommTemplates();
  }

  async editTemplate(templateId?: number) {
    console.log('EDITING TEMPLATE ID ' + templateId);

    var t: ICommsTemplate = null;

    // If we're loading a template/wrapper based on an ID
    if (templateId != null) {
      await this.searchCommTemplates({ id: templateId }).then((x) => {
        if (x != null) {
          t = x[0];
        }
      });
    } else {
      // Loading a template based on a selected item
      t = this.selectedTemplate;
    }

    this.fetchCommEventChoices();

    await this.fetchExcludedCustomers(t.id).then((response) => {});

    this.changedCommsEvent(t.commsEventId);

    this.showEditForm = true;

    await this.patchForm(t);
  }

  async fetchExcludedCustomers(templateId: number) {
    this.excludedCustomers = [];
    this.includedCustomers = this.exclusionChoices;
    this.excludedCount = 0;

    if (templateId) {
      this.commsTemplateService
        .fetchExcludedCustomers(templateId)
        .then((response: ICommsTemplateExclude[]) => {
          this.excludedCount = response.length;

          response.forEach((x) => {
            var item = <SelectItem>{ value: x.customerId, label: x.customer.name };

            let index = this.includedCustomers.find((i) => i.value === x.customerId);

            if (index != null) {
              let index2 = this.includedCustomers.indexOf(index);
              this.includedCustomers = this.includedCustomers
                .slice(0, index2)
                .concat(this.includedCustomers.slice(index2 + 1));
            }

            this.excludedCustomers = [...this.excludedCustomers, item];
          });
        });
    }
  }

  async patchForm(t) {
    this.formGroup.patchValue({
      id: t.id,
      commsType: t.commsType.toString(),
      commsEventId: t.commsEventId,
      customerId: t.customerId,
      subjectTemplate: t.subjectTemplate,
      bodyTemplate: t.bodyTemplate,
      bccAddress: t.bccAddress,
      senderAddress: t.senderAddress,
      senderName: t.senderName ? t.senderName : 'Engineius',
      replyToAddress: t.replyToAddress,
      replyToName: t.replyToName,
      recipientAddress: t.recipientAddress,
      recipientName: t.recipientName,
      active: t.active,
      isWrapper: t.isWrapper,
      wrapperId: t.wrapperId,
      wrapper: t.wrapper,
      templateName: t.templateName,
      allowDuplicate: t.allowDuplicate,
      uniqueIdTemplate: t.uniqueIdTemplate,
      templateFile: t.templateFile,
    });
  }

  get f() {
    return this.formGroup.value;
  }

  async addTemplate() {
    this.showEditForm = true;
    this.selectedTemplate = null;
    this.fetchCommEventChoices();
    this.fetchExcludedCustomers(null);

    this.formGroup.reset();

    this.formGroup.patchValue({ allowDuplicate: false });
  }

  private fetchTemplateFileChoices() {
    this.commsTemplateService.fetchTemplateFileChoices().then((x) => {
      this.templateFileChoices = x.map((y) => {
        return { value: y, label: y };
      });

      this.templateFileChoices.unshift({ value: 'None', label: 'None' });
    });
  }

  closeEditForm() {
    this.showEditForm = false;
  }
}
